export default "__VITE_ASSET__CxuztQaE__"